import { Component, Input } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { SubscriptionCheckerComponent } from "../subscription-checker.component";
import { StaticDataService } from "app/shared/services/static-data.service";
import { SUBSCRIPTIONS } from "app/constants/subscriptions";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.template.html",
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent extends SubscriptionCheckerComponent {
  @Input("items") public menuItems: any[] = [];
  @Input("hasIconMenu") public hasIconTypeMenuItem: boolean;
  @Input("iconMenuTitle") public iconTypeMenuTitle: string;

  readonly SUBSCRIPTIONS = SUBSCRIPTIONS;

  constructor(
    staticService: StaticDataService,
    oidcSecurityService: OidcSecurityService    
  ) {
    super(staticService, oidcSecurityService);
  }

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: "ITEM",
      type: "dropDown",
      tooltip: "Item",
      icon: "done",
      state: "material",
      sub: [
        { name: "SUBITEM", state: "cards" },
        { name: "SUBITEM", state: "buttons" }
      ]
    });
  }

  dropdownDisabled(state: string): boolean {
    if (
      state == 'salto_space' && 
      !this.hasSubscription(SUBSCRIPTIONS.SALTO) && 
      !this.hasSubscription(SUBSCRIPTIONS.DIGITAL_CRED)
    ) {
      return true;
    }

    if (
      !this.hasSubscription(SUBSCRIPTIONS.DIGITAL_CRED) && state == 'hid_apple_wallet' ||
      !this.hasSubscription(SUBSCRIPTIONS.DIGITAL_CRED) && state == 'wavelynx' ||
      !this.hasSubscription(SUBSCRIPTIONS.HID_CONNECT) && state == 'hid_connect'
    ) {
      return true;
    }

    if (
      !this.hasSubscription(SUBSCRIPTIONS.ADMISSION) && 
      !this.hasSubscription(SUBSCRIPTIONS.STAND) && 
      state == 'admission'
    ) {
      return true;
    }

    return false;
  }
}
